import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { NavLinkPath } from '../Nav.types';

export const useIsNavItemActive = () => {
  const { pathname: routerPathName } = useRouter();

  return useCallback((path: NavLinkPath) => routerPathName.includes(path), [routerPathName]);
};
